import { createSelector } from '@ngrx/store';
import { CheckoutState } from '../reducers/checkout.reducer';
import {
  getTransferConnectState,
  TransferConnectV2State,
} from '../reducers/index';

const getCheckoutState = createSelector(
  getTransferConnectState,
  (state: TransferConnectV2State) => state.checkout,
);

const getLoyaltyProgramsFormData = (state: CheckoutState) =>
  state.loyaltyProgramsFormData;
const getPointsTransferLoading = (state: CheckoutState) =>
  state.pointsTransfer.loading;
const getPointsTransferError = (state: CheckoutState) =>
  state.pointsTransfer.error;

const getCheckoutLoyaltyPrograms = createSelector(
  getCheckoutState,
  getLoyaltyProgramsFormData,
);

export const getCheckoutFormData = createSelector(
  getCheckoutLoyaltyPrograms,
  (
    loyaltyProgramsFormData: CheckoutState['loyaltyProgramsFormData'],
    props: { id: string },
  ) => {
    return loyaltyProgramsFormData[props.id] || null;
  },
);

export const getCheckoutPointsTransferLoading = createSelector(
  getCheckoutState,
  getPointsTransferLoading,
);

export const getCheckoutPointsTransferError = createSelector(
  getCheckoutState,
  getPointsTransferError,
);
